export const timeOptions = [
  { label: 'Midnight', value: 'midnight', id: 'midnight' },
  { label: 'Noon', value: 'noon', id: 'noon' },
  { label: 'AM/PM Hours', value: 'am/pm', id: 'am/pm' },
];

export const timeZoneOptions = [
  { label: 'Asia/Calcutta', value: 'asia/calcutta', id: 'asia/calcutta' },
];

export const daySelectionOptions = [
  { label: 'Monday', value: 'monday', id: 'monday' },
  { label: 'Tuesday', value: 'tuesday', id: 'tuesday' },
  { label: 'Wednesday', value: 'wednesday', id: 'wednesday' },
  { label: 'Thursday', value: 'thursday', id: 'thursday' },
  { label: 'Friday', value: 'friday', id: 'friday' },
  { label: 'Saturday', value: 'saturday', id: 'saturday' },
  { label: 'Sunday', value: 'sunday', id: 'sunday' },
];

export const monthDaysOptions = Array?.from({ length: 31 }, (_, i) => ({
  label: `${i + 1}`,
  value: `${i + 1}`,
  id: `${i + 1}`,
}));

export const placeholderMapping: Record<string, string> = {
  time_options: 'Select a time',
  timezone_dropdown: 'Select a timezone',
  day_of_month_dropdown: 'Select a day of the month',
  day_selection: 'Select a day',
  interval_range: 'Interval range',
  toggle_weekends: 'Toggle weekends',
};
